export default "__VITE_ASSET__DsS2cdKG__"